import { createAction, props } from "@ngrx/store";
import { ActionError } from "../../models/action-error";

export const loadError = createAction(
  '[Error] Load Error', props<ActionError>()
);